import type { ObservabilityEvent } from '@/model/observability/controlPlane.generated';
import type { TimelineResponse } from '@/model/observability/dto.generated';
import type {
  ActivityEventView,
  ActivityStatusKey,
} from '@/viewmodel/features/observability/types';

function isErrorEvent(e: ObservabilityEvent): boolean {
  return e.level === 'error' || e.status === 'failed' || e.status === 'error';
}

export function toActivityEventView(e: ObservabilityEvent): ActivityEventView {
  const errored = isErrorEvent(e);
  return {
    id: e.id,
    text: e.message ?? e.event_type,
    status: e.status,
    errored,
    completed: !errored && e.status === 'completed',
  };
}

export function isTimelineTerminal(data: TimelineResponse | undefined): boolean {
  const calls = data?.timeline.calls ?? [];
  return calls.length > 0 && calls.every((c) => c.terminal);
}

export function activityStatusKey(
  isLoading: boolean,
  isError: boolean,
  isTerminal: boolean,
): ActivityStatusKey {
  if (isLoading) return 'loading';
  if (isError) return 'error';
  return isTerminal ? 'done' : 'inProgress';
}
